import { createStyles, makeStyles, Theme, styled } from '@material-ui/core';

export const Spacing = styled('div')({
  flex: '1 1 auto',
})

export const getRootStyles = makeStyles((theme: Theme) => createStyles({

  modalContent: {
    minHeight: '50px',
    padding: '16px 24px',
  },
  modalFooter: {
    paddingBottom: '16px',
    paddingRight: '24px'
  },
}));